export enum MailingAddressHeight {
    ROW_1 = "row-1",
    ROW_2 = "row-2",
    ROW_3 = "row-3",
    ROW_4 = "row-4"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/mailing-address-height.enum.ts